import { Radio, Form, ConfigProvider, Input } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'translations/hooks';

import {
  useReportProdAnalyzeFilters,
  useReportProdAnalyzeFiltersFormName,
} from 'business/shift-report/report-analyze/pages/production-analyze/providers/filters';
import { GROUP_BY_TYPES_MAP } from 'business/shift-report/report-analyze/pages/production-analyze/types';
import { PreselectTemporalSelectInput } from 'ui/form/preselect-date-select-input';

export interface ReportProdAnalyzeMobileFiltersProps {
  teamSwitchEnabled: boolean;
}

export const ReportProdAnalyzeMobileFilters = ({
  teamSwitchEnabled,
}: ReportProdAnalyzeMobileFiltersProps) => {
  const { t } = useTranslation();
  const formName = useReportProdAnalyzeFiltersFormName();
  const filters = useReportProdAnalyzeFilters();
  const [form] = Form.useForm();

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            inlineItemMarginBottom: 12,
          },
        },
      }}
    >
      <Form layout="inline" form={form} name={formName} initialValues={filters}>
        <Form.Item name="filterType" hidden>
          <Input disabled />
        </Form.Item>
        <Form.Item name="dateRange" label={t('input.dateRange.label')}>
          <PreselectTemporalSelectInput mode="date" defaultDate={dayjs()} />
        </Form.Item>

        {teamSwitchEnabled && (
          <Form.Item
            name="groupByType"
            label={t(
              'reportAnalyze.productionAnalyze.input.groupByOptions.label',
            )}
          >
            <Radio.Group
              optionType="button"
              buttonStyle="solid"
              options={[
                {
                  label: t(
                    'reportAnalyze.productionAnalyze.input.groupByOptions.shift',
                  ),
                  value: GROUP_BY_TYPES_MAP.shift,
                },
                {
                  label: t(
                    'reportAnalyze.productionAnalyze.input.groupByOptions.team',
                  ),
                  value: GROUP_BY_TYPES_MAP.team,
                },
              ]}
            />
          </Form.Item>
        )}
      </Form>
    </ConfigProvider>
  );
};
